import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "io-hero__container" }
const _hoisted_2 = {
  class: "container-fluid",
  ref: "heroContainer"
}
const _hoisted_3 = { class: "io-hero__container__content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  ref: "heroCalculator",
  class: "io-hero__calculator"
}
const _hoisted_6 = { class: "container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseCalculator = _resolveComponent("BaseCalculator")!
  const _component_BaseGridCol = _resolveComponent("BaseGridCol")!
  const _component_BaseGridRow = _resolveComponent("BaseGridRow")!
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(_ctx.heroClasses)
  }, [
    _createVNode(_component_BaseGridRow, {
      "min-height": _ctx.minHeight,
      g: 0,
      "vertical-center": _ctx.contentAlign === 'center',
      "vertical-end": _ctx.contentAlign === 'end'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseGridCol, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_IoHeadline, {
                    size: "h1",
                    "text-align": "start",
                    color: "dark",
                    "color-lg": _ctx.fontColor
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "headline")
                    ]),
                    _: 3
                  }, 8, ["color-lg"]),
                  (_ctx.hasSubline)
                    ? (_openBlock(), _createBlock(_component_IoHeadline, {
                        key: 0,
                        size: "h1",
                        "tag-name": "h2",
                        "text-align": "start",
                        color: "dark",
                        "color-lg": _ctx.fontColor
                      }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "subline")
                        ]),
                        _: 3
                      }, 8, ["color-lg"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasContent)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["io-hero__content", `color-dark color-lg-${_ctx.fontColor}`])
                      }, [
                        _renderSlot(_ctx.$slots, "content")
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.pageUrl)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 2,
                        "page-url": _ctx.pageUrl,
                        color: _ctx.fontColor,
                        "link-type": "page",
                        type: "outline",
                        align: "start"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", { innerHTML: _ctx.pageUrlLabel }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      }, 8, ["page-url", "color"]))
                    : _createCommentVNode("", true),
                  (_ctx.calculatorShow === 'true' && !_ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_BaseCalculator, {
                        key: 3,
                        ref: "calculatorComponent",
                        "label-extra": _ctx.calculatorLabelExtra,
                        branches: _ctx.calculatorBranches,
                        "show-valid-checks": true,
                        onChangeUsageIcon: _ctx.onCalculatorChangeIcon
                      }, null, 8, ["label-extra", "branches", "onChangeUsageIcon"]))
                    : _createCommentVNode("", true)
                ])
              ], 512)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["min-height", "vertical-center", "vertical-end"]),
    _createVNode(_component_LazyBackgroundMedia, {
      ref: "background",
      class: "io-hero__background",
      key: `hero-media-${_ctx.currentMedia.id}`,
      "media-sizes": _ctx.currentMedia.sizes,
      "background-position-y": _ctx.currentMedia.positionY,
      "background-position-x": _ctx.currentMedia.positionX
    }, null, 8, ["media-sizes", "background-position-y", "background-position-x"]),
    (_ctx.calculatorShow === 'true' && _ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_BaseCalculator, {
              ref: "calculatorComponent",
              branches: _ctx.calculatorBranches,
              "label-extra": _ctx.calculatorLabelExtra,
              "show-valid-checks": true,
              onChangeUsageIcon: _ctx.onCalculatorChangeIcon
            }, null, 8, ["branches", "label-extra", "onChangeUsageIcon"])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 2))
}